/**
 * Where a unit's win themes live.
 *
 * An outlined section keeps its win themes on its outline entry
 * (`outline.sections[].themeIds`). A single document's `__document__` unit has
 * no outline entry — its outline is `{ sections: [] }`, and that emptiness is
 * how export, Full response, section counts and readiness recognise a single
 * document, so an entry must not be added. Its themes live on its unit brief
 * instead (`unit_briefs.theme_ids`, written with `useUnitBriefStore.saveThemes`).
 *
 * An outline that does carry a `__document__` entry keeps it as the home, so
 * every reader and writer agrees on ONE place. Mirrors
 * `backend/src/lib/brief-themes.ts`, which the drafter's brief reader uses —
 * keep them in step.
 */

import type { Outline, UnitBriefView } from '@/lib/api'
import { DOCUMENT_SECTION_KEY } from '@/types/scope'

export function themesLiveOnUnitBrief(outline: Outline | null | undefined, sectionKey: string): boolean {
  return (
    sectionKey === DOCUMENT_SECTION_KEY &&
    !(outline?.sections ?? []).some((section) => section.sectionKey === sectionKey)
  )
}

/** The win themes currently linked to a unit, read from wherever they live. */
export function readMappedThemeIds(
  outline: Outline | null | undefined,
  sectionKey: string,
  brief: Pick<UnitBriefView, 'themeIds'> | undefined,
): string[] {
  if (themesLiveOnUnitBrief(outline, sectionKey)) return brief?.themeIds ?? []
  return outline?.sections?.find((section) => section.sectionKey === sectionKey)?.themeIds ?? []
}
